import { FC, ReactNode } from 'react'
import { AdminAvatar, AdminAvatarType } from './Avatar'
import { AdminSelectRole, AdminSelectRoleType } from './SelectRole'

const Admin: FC & AdminAvatarType & AdminSelectRoleType = (): ReactNode => <></>

Admin.Avatar = AdminAvatar
Admin.SelectRole = AdminSelectRole

export default Admin
